import React from 'react'
import { useStyles } from './LayoutWrapperActions.styles'
import { Typography } from '@mui/material'

export type LayoutWrapperActionBuilderType = 'component' | 'iconWithText'
export interface LayoutWrapperActionData {
  key: string
  component: JSX.Element
  text: string
  type: LayoutWrapperActionBuilderType
  onClick?: () => void
}
export interface LayoutWrapperActionProps {
  actions: LayoutWrapperActionData[]
}
export const LayoutWrapperActions: React.FC<LayoutWrapperActionProps> = ({
  actions,
}) => {
  const { classes } = useStyles()
  const iconsWithText = actions.filter(action => action.type === 'iconWithText')
  const components = actions.filter(action => action.type === 'component')
  const noOps = () => void 0
  return (
    <div className={classes.actionsContainer}>
      {iconsWithText.map((action, index) => (
        <div className={classes.actionsWrapper} data-testid="action-icons">
          <div key={action.key} className={classes.actionWithDivider}>
            <div
              className={classes.iconWrapper}
              onClick={action?.onClick || noOps}
            >
              {action.component}
              <Typography className={classes.text}>{action.text}</Typography>
            </div>
            {index === iconsWithText.length - 1 && (
              <div className={classes.divider} data-testid="action-divider" />
            )}
          </div>
        </div>
      ))}
      {components.map(action => (
        <div key={action.key} data-testid="action-component">
          {action.component}
        </div>
      ))}
    </div>
  )
}
